import CloseIcon from '@/assets/icons/close.svg?react';
import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type CloseAlertButtonProps = ComponentPropsWithoutRef<'button'>;

export const CloseAlertButton: FC<CloseAlertButtonProps> = ({ className, ...rest }) => (
  <button
    {...rest}
    className={twMerge('text-brand-600 rounded-lg', 'focus:shadow-none focus:outline-none focus:ring-2 focus:ring-brand-600 focus:ring-offset-2', className)}
  >
    <CloseIcon />
  </button>
);
